export { default as CoreNav } from './component';
